import { Injectable } from '@angular/core';

/**
 * Durée pendant laquelle les notifications d'erreur sont tues après le début d'une déconnexion.
 * Calibrée sur le cas réel d'EB-664 : à l'expiration, plusieurs appels sont en vol simultanément et
 * échouent en quelques centaines de millisecondes.
 */
export const LOGOUT_SILENCE_WINDOW_MS = 5_000;

/**
 * Porte l'unique information dont l'intercepteur HTTP a besoin : une déconnexion vient-elle d'être
 * engagée ? (EB-664)
 *
 * **Fenêtre temporelle et non drapeau à effacer.** Un drapeau qu'on oublierait de remettre à `false`
 * rendrait toutes les erreurs silencieuses pour le reste de la session — la perte de signal que la
 * décision produit du 2026-08-31 voulait précisément éviter en retenant le périmètre le plus étroit.
 * Une fenêtre se referme seule ; elle ne peut pas rester coincée.
 *
 * **Ne pas déduire cet état de l'URL du routeur** : la navigation vers `/auth/login` est asynchrone et
 * l'utilisateur peut s'y trouver légitimement, sans déconnexion en cours.
 */
@Injectable({ providedIn: 'root' })
export class LogoutInProgressService {
    private lastLogoutStartedAt: number | null = null;

    /** À appeler au moment où une déconnexion est engagée. */
    public notifyLogoutStarted(): void {
        this.lastLogoutStartedAt = Date.now();
    }

    public isLogoutInProgress(): boolean {
        if (this.lastLogoutStartedAt === null) {
            return false;
        }
        return Date.now() - this.lastLogoutStartedAt <= LOGOUT_SILENCE_WINDOW_MS;
    }
}
